import { Reveal } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Pedí mi Diver Heritage por WhatsApp un lunes y el viernes ya lo tenía en Madrid. La calidad es brutal por el precio.",
    name: "Lucas G.",
    role: "Cliente · Madrid",
  },
  {
    quote:
      "Llevaba años queriendo un AP Royal Oak. Por menos de $300 tengo el estilo sin el problema bancario. Atención impecable.",
    name: "Sofía M.",
    role: "Clienta · Barcelona",
  },
  {
    quote:
      "Lo importante: nadie nota la diferencia. Acabados, peso, sensación al cerrar el broche... todo está donde debe estar.",
    name: "Henrik L.",
    role: "Cliente · Rotterdam",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-2xl mb-20">
          <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-[var(--brand-gold)]" />
            Lo que dicen nuestros clientes
          </div>
          <h2 className="font-serif-rw text-4xl sm:text-5xl font-light leading-[1.05] tracking-tight text-slate-50">
            Pequeños lujos, <em className="italic text-[var(--brand-gold)] font-light">grandes sonrisas.</em>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 100}
              className="bg-[var(--brand-bg)] p-10 sm:p-12 flex flex-col justify-between min-h-[320px]"
            >
              <div>
                <div className="font-serif-rw text-5xl text-[var(--brand-gold)]/40 leading-none mb-6">
                  &ldquo;
                </div>
                <p className="text-base sm:text-lg text-slate-200 leading-relaxed font-light italic">
                  {t.quote}
                </p>
              </div>
              <div className="mt-10 pt-6 border-t border-white/10">
                <div className="font-accent-rw text-sm text-slate-100">
                  {t.name}
                </div>
                <div className="font-accent-rw text-[10px] uppercase tracking-[0.28em] text-slate-500 mt-1">
                  {t.role}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
